export const appointments = [
    {
        id:         1,
        jobType:    'Website Re-Design Plan',
        startDate:  new Date('2021-05-27T16:30:00.000Z'),
        endDate:    new Date('2021-05-27T18:30:00.000Z'),
        status:     'Complete',
        employeeID: 2
    }, {
        id:         2,
        jobType:    'Book Flights to San Fran for Sales Trip',
        startDate:  new Date('2021-05-27T19:00:00.000Z'),
        endDate:    new Date('2021-05-27T20:00:00.000Z'),
        allDay:     true,
        status:     'Scheduled',
        employeeID: 4
    }, {
        id:         3,
        jobType:    'Install New Router in Dev Room',
        startDate:  new Date('2021-05-27T21:30:00.000Z'),
        endDate:    new Date('2021-05-27T22:30:00.000Z'),
        status:     'Rescheduled',
        employeeID: 5
    }, {
        id:         4,
        jobType:    'Approve Personal Computer Upgrade Plan',
        startDate:  new Date('2021-05-27T17:00:00.000Z'),
        endDate:    new Date('2021-05-27T18:00:00.000Z'),
        status:     'Tech Dispatched',
        employeeID: 6
    }, {
        id:         5,
        jobType:    'Final Budget Review',
        startDate:  new Date('2021-05-27T19:00:00.000Z'),
        endDate:    new Date('2021-05-27T20:35:00.000Z'),
        status:     'Tech Arrived',
        employeeID: 2
    }, {
        id:         6,
        jobType:    'New Brochures',
        startDate:  new Date('2021-05-27T21:30:00.000Z'),
        endDate:    new Date('2021-05-27T22:45:00.000Z'),
        status:     'Work Started',
        employeeID: 3
    }, {
        id:         7,
        jobType:    'Install New Database',
        startDate:  new Date('2021-05-27T16:45:00.000Z'),
        endDate:    new Date('2021-05-27T18:15:00.000Z'),
        status:     'Work Completed',
        employeeID: 1
    }, {
        id:         8,
        jobType:    'Approve New Online Marketing Strategy',
        startDate:  new Date('2021-05-27T19:00:00.000Z'),
        endDate:    new Date('2021-05-27T21:00:00.000Z'),
        status:     'Canceled',
        employeeID: 4
    }, {
        id:         9,
        jobType:    'Upgrade Personal Computers',
        startDate:  new Date('2021-05-27T22:15:00.000Z'),
        endDate:    new Date('2021-05-27T23:30:00.000Z'),
        status:     'Open',
        employeeID: 2
    }, {
        id:         10,
        jobType:    'Customer Workshop',
        startDate:  new Date('2021-05-27T10:00:00.000Z'),
        endDate:    new Date('2021-05-27T12:00:00.000Z'),
        allDay:     true,
        status:     'Open',
        employeeID: 1
    }, {
        id:         11,
        jobType:    'Prepare 2021 Marketing Plan',
        startDate:  new Date('2021-05-27T13:00:00.000Z'),
        endDate:    new Date('2021-05-27T15:30:00.000Z'),
        status:     'Scheduled',
        employeeID: 4
    }, {
        id:         12,
        jobType:    'Brochure Design Review',
        startDate:  new Date('2021-05-27T21:00:00.000Z'),
        endDate:    new Date('2021-05-27T22:30:00.000Z'),
        status:     'Rescheduled',
        employeeID: 5
    }, {
        id:         13,
        jobType:    'Create Icons for Website',
        startDate:  new Date('2021-05-28T17:00:00.000Z'),
        endDate:    new Date('2021-05-28T18:30:00.000Z'),
        status:     'Open',
        employeeID: 8
    }, {
        id:         14,
        jobType:    'Upgrade Server Hardware',
        startDate:  new Date('2021-05-28T21:30:00.000Z'),
        endDate:    new Date('2021-05-28T23:00:00.000Z'),
        status:     'Open',
        employeeID: 9
    }, {
        id:         15,
        jobType:    'Submit New Website Design',
        startDate:  new Date('2021-05-27T23:30:00.000Z'),
        endDate:    new Date('2021-05-30T01:00:00.000Z'),
        status:     'Open',
        employeeID: 7
    }, {
        id:         16,
        jobType:    'Launch New Website',
        startDate:  new Date('2021-05-28T19:20:00.000Z'),
        endDate:    new Date('2021-05-28T21:00:00.000Z'),
        status:     'Open',
        employeeID: 8
    }
];

export const tasks = [
    {
        id:           1,
        employeeName: 'Murray Mchenry',
        jobType:      'Job',
        status:       'Open'
    }, {
        id:           2,
        employeeName: 'Murray Mchenry',
        jobType:      'Service Call',
        status:       'Scheduled'
    }, {
        id:           3,
        employeeName: '',
        jobType:      'Job',
        status:       'Rescheduled'
    }, {
        id:           4,
        employeeName: 'Murray Mchenry',
        jobType:      'Service Call',
        status:       'Canceled'
    }, {
        id:           5,
        employeeName: 'Felipe Pereyra',
        jobType:      'Service Call',
        status:       'Work Completed'
    }
];

export const serviceTechnicians = [{
    employeeName:   'Dwaine Tesar',
    id:             1,
    specifications: ['Specilization A']
},
{
    employeeName:   'Felipe Pereyra',
    id:             2,
    specifications: ['Specilization A']
},
{
    employeeName:   'Murray Mchenry',
    id:             3,
    specifications: ['Specilization B']
}, 
{
    employeeName:   'Nathan Shehorn',
    id:             4,
    specifications: ['Specilization C']
}, 
{
    employeeName:   'Orlando Ayres',
    id:             5,
    specifications: ['Specilization C']
}, 
{
    employeeName:   'Sean Garrity',
    id:             6,
    specifications: ['Specilization C', 'Specilization B', 'Specilization D']
}, 
{
    employeeName:   'Sergio Frisina',
    id:             7,
    specifications: ['Specilization D', 'Specilization B', 'Specilization D', 'Specilization A']
}, 
{
    employeeName:   'Dwain Teaser 1',
    id:             8,
    specifications: ['Specilization A']
}, 
{
    employeeName:   'Philip Louis 1',
    id:             9,
    specifications: ['Specilization A']
},
{
    employeeName:   'Felipe Pereyra 1',
    id:             10,
    specifications: ['Specilization A']
},
{
    employeeName:   'Murray Mchenry 1',
    id:             11,
    specifications: ['Specilization B']
}, 
{
    employeeName:   'Nathan Shehorn 1',
    id:             12,
    specifications: ['Specilization C']
}, 
{
    employeeName:   'Orlando Ayres 1',
    id:             13,
    specifications: ['Specilization C']
}, 
{
    employeeName:   'Sean Garrity 1',
    id:             14,
    specifications: ['Specilization C', 'Specilization B', 'Specilization D']
}, 
{
    employeeName:   'Sergio Frisina 2',
    id:             15,
    specifications: ['Specilization D', 'Specilization B', 'Specilization D', 'Specilization A']
}, 
{
    employeeName:   'Dwain Teaser 2',
    id:             16,
    specifications: ['Specilization A']
}, 
{
    employeeName:   'Philip Louis 2',
    id:             17,
    specifications: ['Specilization A']
}];
